import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/tracking/lead-lag')({
  component: () => <PageStub title="Lead/Lag Dashboard" description="Leading and lagging indicators" />,
});
